module.exports = __webpack_public_path__ + "static/media/laptop.ea59c6ad.png";